<template>
  <div>
  <v-dialog v-model="internalDialog" max-width="600px">
    <v-card>
        <v-card-title class="justify-space-between">
        </v-card-title>
        <v-card-text class="px-5">
          <v-row>
            <v-col
              v-for="(img, i) in gallery"
              :key="i"
              cols="6"
              sm="6"
              md="4"
            >
              <v-img :src="img" aspect-ratio="1" class="rounded" @click="viewFullImage(img)"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
  </v-dialog>
  <!-- Dialog: Full Image View -->
  <v-dialog v-model="showFullImage" max-width="400px">
      <v-card>
        <v-card-title class="justify-space-between">
          <span class="text-h6"></span>
          <v-btn icon @click="showFullImage = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="d-flex justify-center">
          <v-img :src="selectedImage" max-width="100%" max-height="80vh" contain />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'ProductDialog',
  props: {
    gallery: {
      type: Array,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalDialog: this.value,
      showFullImage: false,
      selectedImage: ''
    }
  },
  watch: {
    value (val) {
      this.internalDialog = val
    },
    internalDialog (val) {
      this.$emit('input', val) // sync กับ parent
    }
  },
  methods: {
    close () {
      this.internalDialog = false
    },
    viewFullImage (imageUrl) {
      this.selectedImage = imageUrl
      this.showFullImage = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VelaStudio/DialogPreView.vue